import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output
} from '@angular/core';
// Rxjs dependencies.
import { BehaviorSubject, Observable } from 'rxjs';
// Relative dependencies.
import { AuthService, ApiService } from '../../core/upgraded-providers';
import { ITEM_SHOP_URL } from '../store-urls';
import { ShowDlgStoreAccessKeyService } from '../show-dlg-store-access-key.service';

@Component({
  selector: 'app-get-access',
  templateUrl: './get-access.component.pug',
  styleUrls: ['./get-access.component.less']
})
export class GetAccessComponent {
  @HostBinding('class.--ui') _ui = true;

  itemShopUrl = ITEM_SHOP_URL;

  @Input() shard = 'shardX';
  @Input() max = 0;

  private _amountSbj: BehaviorSubject<number> = new BehaviorSubject(0);
  amount$: Observable<number> = this._amountSbj.asObservable();

  @Input() set amount(amount: number) {
    this._amountSbj.next(amount >= 0 ? amount : 0);
    this.onChange(this.value);
  }

  value = 0;

  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() getAccess: EventEmitter<number> = new EventEmitter();

  get limit(): number {
    return Math.max(this.max, this._amountSbj.getValue() * 30);
  }

  get keysNeeded(): number {
    return Math.ceil(this.value / 30);
  }

  get user() {
    return this._authService.Me;
  }

  constructor(
    private _authService: AuthService,
    private _showDlgStoreAccessKey: ShowDlgStoreAccessKeyService,
  ) {
    // Noop.
  }

  onChange(value: number) {
    const parsed = Number(value);

    if (Number.isNaN(parsed)) {
      this.value = 0;
      return;
    }

    this.value = Math.max(0, Math.min(this.limit, Math.round(parsed / 30) * 30));
  }

  onClose() {
    this.close.emit();
  }

  protected onGetAccess() {
    if (this.value < 1) {
      return;
    }

    this.getAccess.emit(this.keysNeeded);
  }

  protected onBuyMore() {
    this._showDlgStoreAccessKey.show({
      steam: this.user.steam,
      amount: this.user.resources && this.user.resources.accessKey || 0,
      unlimitedAccessKeys: this.user.isUnlimittedAccessKeysSubscriber(),
    });
  }
}